<template>
    <div class="actions">
        <div class="left">
            <div v-if="isChildView" @click="openParentClaim()" class="button">
                <fa-icon class="mirrored" icon="level-up-alt"></fa-icon>
                <div class="action-label">Back to Parent</div>
            </div>
        </div>
        <div class="right">
            <div v-if="userInvite !== undefined" v-on-clickaway="endInviteUser" class="invite-input">
                <input type="text" placeholder="Email Address" v-model="userInvite">
            </div>
            <div @click="startInviteUser" class="button">
                <fa-icon icon="user-plus"></fa-icon>
                <div class="action-label">Invite User</div>
            </div>
        </div>
    </div>
</template>

<script>
    import { mixin as clickaway } from 'vue-clickaway';

    export default {
        mixins: [ clickaway ],
        props: {
            isChildView: Boolean
        },
        methods: {
            openParentClaim() {
                this.$emit('openParentClaim');
            },
            startInviteUser(e) {
                this.userInvite = null;
            },
            endInviteUser() {
                this.$emit('inviteUser', this.userInvite);
                this.userInvite = undefined;
            }
        },
        data() {
            return {
                userInvite: undefined,
            };
        }
    }
</script>

<style scoped lang="scss">
    .actions {
        position: relative;
        width: 100%;
        height: $space-32;
        margin-bottom: $space-32;
        text-align: left;
        color: $dark-gray;

        .invite-input {
            width: $space-256;

            > input {
                width: 100%;
            }
        }

        .left, .right {
            > div {
                display: inline-block;
            }

            > .button {
                cursor: pointer;
                padding: $space-8;
                border-radius: $rounded-corners;

                &:hover {
                    background-color: rgba(255, 255, 255, 0.2);
                }

                > * {
                    height: $space-32;
                    vertical-align: middle;
                }

                svg {
                    width: $space-32;
                }
                .action-label {
                    display: inline-block;
                    line-height: $space-32;
                    margin-left: $space-8;
                }
            }
        }

        .left {
            position: absolute;
            left: 0;
        }
        .right {
            position: absolute;
            right: 0;
        }
    }
</style>